import {
  FETCH_THRESHOLD_STATUS,
  FETCH_THRESHOLD_STATUS_SUCCESS,
  FETCH_THRESHOLD_STATUS_FAIL,
  TRIGGER_THRESHOLD_GENERATION,
  TRIGGER_THRESHOLD_GENERATION_SUCCESS,
  TRIGGER_THRESHOLD_GENERATION_FAIL,
  DISCARD_THRESHOLD_GENERATION,
  DISCARD_THRESHOLD_GENERATION_SUCCESS,
  DISCARD_THRESHOLD_GENERATION_FAIL,
  FETCH_THRESHOLD_RESULTS,
  FETCH_THRESHOLD_RESULTS_SUCCESS,
  FETCH_THRESHOLD_RESULTS_FAIL,
  FETCH_THRESHOLD_CONFIG,
  FETCH_THRESHOLD_CONFIG_SUCCESS,
  THRESHOLD_GENERATION_RESET
} from '../../actions/trm/thresholdGeneration';

export const initialState = {
  generationState: 'configuring',
  isTriggering: false,
  results: null,
  config: null,
  startedAt: null,
  error: null
};

export default function thresholdGeneration(state = initialState, action) {
  switch (action.type) {
    case FETCH_THRESHOLD_STATUS:
      return {
        ...state,
        error: null
      };
    case FETCH_THRESHOLD_STATUS_SUCCESS:
      return {
        ...state,
        generationState:
          action.payload.status === 'COMPLETED'
            ? 'generated'
            : action.payload.status === 'RUNNING'
            ? 'generating'
            : 'configuring',
        startedAt: action.payload.startedAt || state.startedAt,
        error: null
      };
    case FETCH_THRESHOLD_STATUS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case TRIGGER_THRESHOLD_GENERATION:
      return {
        ...state,
        isTriggering: true,
        error: null
      };
    case TRIGGER_THRESHOLD_GENERATION_SUCCESS:
      return {
        ...state,
        isTriggering: false,
        generationState: 'generating',
        startedAt: action.payload.startedAt || new Date().toISOString(),
        error: null
      };
    case TRIGGER_THRESHOLD_GENERATION_FAIL:
      return {
        ...state,
        isTriggering: false,
        // A failed trigger never started anything — clear any in-flight banner
        // state so the UI doesn't show a phantom "generating" status.
        generationState: 'configuring',
        startedAt: null,
        error: action.payload
      };

    case DISCARD_THRESHOLD_GENERATION:
      return {
        ...state,
        isTriggering: true,
        error: null
      };
    case DISCARD_THRESHOLD_GENERATION_SUCCESS:
      return {
        ...state,
        isTriggering: false,
        generationState: 'configuring',
        results: null,
        startedAt: null,
        error: null
      };
    case DISCARD_THRESHOLD_GENERATION_FAIL:
      return {
        ...state,
        isTriggering: false,
        error: action.payload
      };

    case FETCH_THRESHOLD_RESULTS:
      return {
        ...state,
        error: null
      };
    case FETCH_THRESHOLD_RESULTS_SUCCESS: {
      const hasResults =
        action.payload &&
        action.payload.rules &&
        action.payload.rules.length > 0;
      return {
        ...state,
        results: hasResults ? action.payload : null,
        generationState: hasResults ? 'generated' : state.generationState,
        error: null
      };
    }
    case FETCH_THRESHOLD_RESULTS_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case FETCH_THRESHOLD_CONFIG:
      return {
        ...state,
        error: null
      };
    case FETCH_THRESHOLD_CONFIG_SUCCESS:
      return {
        ...state,
        config: action.payload,
        error: null
      };

    case THRESHOLD_GENERATION_RESET:
      return { ...initialState };

    default:
      return state;
  }
}
